import type { ILogoImageProps } from 'src/interfaces';

export const getCustomLogoImageProps = (): ILogoImageProps | null => {
  try {
    if (window.LOGO_IMAGE_PROPS) {
      return JSON.parse(window.LOGO_IMAGE_PROPS);
    }
  } catch (e) {
    console.log(e);
  }

  return null;
};
